import { Map } from 'immutable';
import { constants as authConstants } from '@saucelabs/sl-container-authentication';

import * as constants from './constants';


const initialState = new Map({
  initialized: false,
  unauthenticated: false,
});

const appReducer = (state = initialState, { type }) => {
  switch (type) {
    case constants.INITIALIZE.REQUEST:
      return state.set('initialized', false);
    case constants.INITIALIZE.FAILURE:
    case constants.INITIALIZE.SUCCESS:
      return state.set('initialized', true);
    case authConstants.LOGIN.SUCCESS:
      return state.set('unauthenticated', false);
    case authConstants.LOGOUT.SUCCESS:
    case authConstants.WHOAMI_JWT_GET.FAILURE:
      return state.set('unauthenticated', true);
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default appReducer;
export { initialState };
